import { v1ApiClient } from '@/services';
import type { PathParams, RequestBody } from '@/shared/api/generated';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

type HideIssuePath = '/v1/workspaces/{workspace_id}/issues/hide';

type HideIssueParams = Partial<PathParams<HideIssuePath, 'patch'>> &
  RequestBody<HideIssuePath, 'patch'>;
type HideIssueFunction = (params: HideIssueParams) => Promise<void>;

/**
 * 이슈 숨기기 토글
 */
export const hideIssue: HideIssueFunction = ({
  workspace_id,
  name,
  hidden,
}) => {
  const wa = workspace_id ?? getCurrWorkspaceAlias();
  return v1ApiClient
    .patch(`/workspaces/${wa}/issues/hide`, { name, hidden })
    .then((res) => res.data);
};
